var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBadmintonServe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  clipPath: "url(#badmintonServe_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m13.93 15.265-.662-.663 1.326-1.326.663.663a.937.937 0 1 1-1.326 1.326m-.663-4.641 1.326 2.651m-3.978.001 2.652 1.326m.442-3.095-2.21 2.21m2.436-6.343c-1.833 1.832-4.507 2.13-5.973.663s-1.17-4.14.663-5.973S13.134-.066 14.6 1.4s1.169 4.14-.664 5.974m.664-5.975L5.11 10.89m-3.315 4.641L.469 14.205l3.314-3.314a.938.938 0 0 1 1.326 1.326zM7.09 6.258 12.831.516M9.741 8.91l5.742-5.742M13.885 7.31 8.688 2.114M1.794 12.88l1.326 1.325"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "badmintonServe_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgBadmintonServe;